import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import CircularWithValueLabel from '../../components/circular-progress';
import ImageSlide from '../../components/slide/ImageSlide';
import VideoSlide from '../../components/slide/VideoSlide';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const FanTentPage = (props) => {
  const [isFirstSlideLoading, setIsFirstSlideLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isFirstSlideLoading) {
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isFirstSlideLoading]);

  useEffect(() => {
    if (isLoading) return;

    const timeoutId = setTimeout(() => {
      setIndex((index) => {
        let nextIndex = 0;
        if (index < Object.keys(slideIntervals).length) nextIndex = index + 1;
        console.log(`Active slide: ${nextIndex}`);
        return nextIndex;
      });
    }, slideIntervals[index]);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [index, isLoading]);

  const slideIntervals = {
    0: 500,
    1: 30000,   // Video: Grit to Vision
    2: 500,
    3: 30000,   // Image: JR Fooch Partnership
    4: 500,
    5: 30000,   // Image: Good Luck Justin Rose
    6: 500,
    7: 30000,   // Video: Behind the Drive
    8: 500,
    9: 30000,   // Image: First Tee Messaging
    10: 500,
    11: 30000   // Image: Morgan Stanley Institute
  };

  const customRenderItem = (item, props) => (
    <item.type {...item.props} {...props} />
  );

  return (
    <div className="App">
      {isLoading ? <CircularWithValueLabel /> : null}
      <Carousel
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        infiniteLoop={true}
        transitionTime={5}
        stopOnHover={false}
        swipeable={false}
        useKeyboardArrows={false}
        showIndicators={false}
        autoPlay={false}
        renderItem={customRenderItem}
        selectedItem={index}
      >
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <VideoSlide
          playing={index === 1}
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/grit_to_vision_h.mp4"
          setIsLoading={setIsFirstSlideLoading}
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/jr_fooch_partnership_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/good_luck_justin_rose_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <VideoSlide
          playing={index === 7}
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/behind_the_drive_h.mp4"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/first_tee_messaging_h.jpg"
          orientation="landscape"
        />
        <ImageSlide url="/black.jpg" orientation="landscape" />
        <ImageSlide
          url="https://bitworthy-f7dec4aehddqcnag.z01.azurefd.net/tma-mstpc/2026/ms_institute_h.png"
          orientation="landscape"
        />
      </Carousel>
    </div>
  );
};

export default FanTentPage;
